import store from "../../app/store";

import VipCard from "./pages/home/store/index";
import huaweiVIP from './pages/huaweiVIP/store/index'
import goldFree from './pages/goldFree/store/index'
import goldSale from './pages/goldSale/store/index'
import receiveFree from './pages/receiveFree/store/index'
import sikuGold from './pages/sikuGold/store/index'

let modules = [{
    path: "vipCard/home",
    moduleName: VipCard
  },
  {
    path: 'vipCard/huaweiVIP',
    moduleName: huaweiVIP
  },
  {
    path: 'vipCard/goldFree',
    moduleName: goldFree
  },
  {
    path: 'vipCard/goldSale',
    moduleName: goldSale
  },
  {
    path: 'vipCard/receiveFree',
    moduleName: receiveFree
  },
  {
    path: 'vipCard/sikuGold',
    moduleName: sikuGold
  }
];

modules.map(({
  path,
  moduleName
}) => {
  store.registerModule(path, moduleName);
});

export default store;



// WEBPACK FOOTER //
// ./src/projects/vipCard/store.js